function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2",
  transform: "translate(-0.8 -0.8)"
}, React.createElement("path", {
  id: "Path_1",
  "data-name": "Path 1",
  d: "M10.711,6.087a.462.462,0,0,0-.462.462V9.324a.925.925,0,0,1-.925.925H2.85a.925.925,0,0,1-.925-.925V2.85a.925.925,0,0,1,.925-.925H5.624a.462.462,0,1,0,0-.925H2.85A1.85,1.85,0,0,0,1,2.85V9.324a1.85,1.85,0,0,0,1.85,1.85H9.324a1.85,1.85,0,0,0,1.85-1.85V6.549A.462.462,0,0,0,10.711,6.087Z",
  transform: "translate(0 0)",
  fill: "#d3d5db",
  stroke: "#d4d5dc",
  strokeWidth: 0.4
}), React.createElement("path", {
  id: "Path_2",
  "data-name": "Path 2",
  d: "M17.051,1.284a.457.457,0,0,0-.086-.129c-.006-.006-.007-.014-.013-.02s-.014-.008-.02-.013A.434.434,0,0,0,16.624,1H13.85a.462.462,0,1,0,0,.925h1.658L12.135,5.3a.462.462,0,1,0,.654.654l3.372-3.373V4.237a.462.462,0,1,0,.925,0V1.462A.458.458,0,0,0,17.051,1.284Z",
  transform: "translate(-5.913 0)",
  fill: "#d3d5db",
  stroke: "#d4d5dc",
  strokeWidth: 0.4
}));

var SvgRedirect = function SvgRedirect(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 10.574,
    height: 10.574,
    viewBox: "0 0 10.574 10.574",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgRedirect, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/redirect.e68fce25.svg";
export { ForwardRef as ReactComponent };